import { useEffect } from 'react';
import { useVideoPlayerContext } from '@/components/VideoPlayer/VideoPlayerProvider';
import { VideoBoundingBox } from '@/components/VideoPlayer/VideoBoundingBox';
import type { FullSource } from '@/types/source';
import type { BoundingBoxData } from '@/types/video-player';
import { getVideoElementFromRef } from '@/utils/video-player';
import { PipPlayerShell } from './PipPlayerShell';

interface PipPlayerLayoutProps {
    boundingBoxProps: BoundingBoxData | undefined;
    source: FullSource;
    startTime: number;
}

export function PipPlayerLayout({
    boundingBoxProps,
    source,
    startTime,
}: PipPlayerLayoutProps) {
    const { activeMediaRef, streaming, emitter, pictureRect, loopTimeRange } =
        useVideoPlayerContext();

    const mediaPlaybackStart = loopTimeRange?.playbackStart ?? startTime;

    useEffect(() => {
        if (
            mediaPlaybackStart == null ||
            streaming.streamBeginTimestamp !== null
        ) {
            return;
        }
        const videoElement = getVideoElementFromRef(activeMediaRef);
        if (videoElement) {
            videoElement.currentTime = mediaPlaybackStart;
        }
    }, [
        mediaPlaybackStart,
        streaming.videoSrc,
        activeMediaRef,
        streaming.streamBeginTimestamp,
    ]);

    const boundingBox =
        boundingBoxProps?.drawBoxes && !streaming.live ? (
            <VideoBoundingBox
                sourceType={source.type}
                pictureRect={pictureRect}
                timeBase={streaming.streamBeginTimestamp ?? undefined}
                frames={boundingBoxProps.frames}
                videoRef={activeMediaRef}
                emitter={emitter}
            />
        ) : null;

    return <PipPlayerShell source={source} overlay={boundingBox} />;
}
